var RG_TECH_CLASS;
(function (RG_TECH_CLASS) {
    /** An area or space that is communal and available for use by the occupants of a building for recreational or social activities. */
    RG_TECH_CLASS["Amenity"] = "Amenity";
    /** An area or space provided in a building to contain equipment associated with building services. */
    RG_TECH_CLASS["Service"] = "Service";
})(RG_TECH_CLASS || (RG_TECH_CLASS = {}));

export { RG_TECH_CLASS };
//# sourceMappingURL=rg-tech-class.js.map
